import Vue from "vue";
import Router from "vue-router";
import { store } from "@/vuex/store";
// import axios from 'axios'
// Containers
import Full from "@/containers/Full";

// Views
// 홈
import DashboardAdv from "@/components/monitoring/DashboardAdv";
// 센서 정보
import SensorDetailInfo from "@/components/sensor/SensorInfo";
// 센서 데이터
import SensorDataChart from "@/components/sensor/SensorDataChart";
// RAWFILE 조회
import RawfileData from "@/components/sensor/RawfileData";
// 이벤트 > 데이터 임계치 이력
import DataThreshold from "@/components/sensor/DataThreshold";
// 게측 데이터 (시계열)
import MeasurementData from "@/components/sensor/MeasurementData";
// 가속도 분석
import AnalysisChart from "@/components/sensor/SensorDataHistory";
// SSI 분석
import SsiAnalysis from "@/components/analysis/SsiAnalysis";
// SSI Octave 분석
import SsiAnalysisOctave from "@/components/analysis/SsiAnalysisOctave";
// 내하력 분석
import LoadCarryingCapacityAnalysis from "@/components/analysis/LoadCarryingCapacityAnalysis";
// 트랜드 분석
import TrendAnalysis from "@/components/analysis/TrendAnalysis";
// FRF 분석
import FrequencyResponseFunction from "@/components/analysis/FrequencyResponseFunction";
// 분석 이력 조회
import AnalysisHistory from "@/components/analysis-history/AnalysisHistory";
// 현장 사진
import ScenePhoto from "@/components/scene-photo/ScenePhoto";
// 보고서
import Report from "@/components/report/Report";
// 모니터링
import SensorMonitoring from "@/components/monitoring/Monitoring";
// 로그인
import Login from "@/components/common/Login";
import ErrorPage from "@/components/error/error404";
import Test3D from "@/components/test/Test3D";
import TestVR from "@/components/test/TestVR";

import VRSensorData from "@/components/vrpopup/VRSensorData";
import VRSiteCheckInfo from "@/components/vrpopup/VRSiteCheckInfo";

import Test3dkyj from "@/components/test-3d-kyj/Test3dkyj";

Vue.use(Router);

const requireAuth = () => async (to, from, next) => {
  // console.log(to)
  // store.dispatch('websockConn')
  // console.log('권한여부 ==> ', store.state.userInfo.loginYn)
  let userInfo = JSON.parse(localStorage.getItem("userInfo"));
  let loginYn = null;
  if (userInfo !== null) {
    if (userInfo.loginYn) {
      store.commit("setUserInfo", {
        loginYn: userInfo.loginYn,
        id: userInfo.id,
        name: userInfo.name,
        auth: userInfo.auth,
      });
    } else {
      store.commit("setUserInfo");
    }
    loginYn = userInfo.loginYn;
    localStorage.removeItem("userInfo");
  } else {
    loginYn = store.state.userInfo.loginYn;
  }
  if (loginYn) {
    store.dispatch('websockConn')
    store.commit("setCurrentPath", to.path);
    return next();
  } else {
    next("/login");
  }
};
export default new Router({
  mode: "hash", // hash history
  linkActiveClass: "open active",
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: "/login",
      name: "Login",
      component: Login,
    },
    {
      path: "/",
      redirect: "/dashboard",
      name: "Home",
      component: Full,
      children: [
        // 종합 관제
        {
          path: "dashboard",
          name: "dashboard",
          component: DashboardAdv,
          beforeEnter: requireAuth(),
        },
        // 센서 정보
        {
          path: "sensorDetailInfo",
          name: "sensorDetailInfo",
          component: SensorDetailInfo,
          beforeEnter: requireAuth(),
        },
        // 센서 데이터
        {
          path: "sensorDataChart",
          name: "sensorDataChart",
          component: SensorDataChart,
          beforeEnter: requireAuth(),
        },
        {
          path: "rawfileData",
          name: "rawfileData",
          component: RawfileData,
          beforeEnter: requireAuth(),
        },
        {
          path: "dataThreshold",
          name: "dataThreshold",
          component: DataThreshold,
          beforeEnter: requireAuth(),
        },
        {
          path: "measurementData",
          name: "measurementData",
          component: MeasurementData,
          beforeEnter: requireAuth(),
        },
        // 정적 분석
        {
          path: "trendAnalysis",
          name: "trendAnalysis",
          component: TrendAnalysis,
          beforeEnter: requireAuth(),
        },
        // 동적 분석
        {
          path: "analysisChart",
          name: "analysisChart",
          component: AnalysisChart,
          beforeEnter: requireAuth(),
        },
        {
          path: "ssiAnalysis",
          name: "ssiAnalysis",
          component: SsiAnalysis,
          beforeEnter: requireAuth(),
        },
        {
          path: "ssiAnalysisOctave",
          name: "ssiAnalysisOctave",
          component: SsiAnalysisOctave,
          beforeEnter: requireAuth(),
        },
        {
          path: "loadCarryingCapacityAnalysis",
          name: "loadCarryingCapacityAnalysis",
          component: LoadCarryingCapacityAnalysis,
          beforeEnter: requireAuth(),
        },
        {
          path: "frequencyResponseFunction",
          name: "frequencyResponseFunction",
          component: FrequencyResponseFunction,
          beforeEnter: requireAuth(),
        },
        // 분석 이력
        {
          path: "analysisHistory", // HICC230125 - Anal...-> anal..
          name: "analysisHistory", // HICC230125 - Anal...-> anal..
          component: AnalysisHistory,
          beforeEnter: requireAuth(),
        },
        // 보고서
        {
          path: "report",
          name: "report",
          component: Report,
          beforeEnter: requireAuth(),
        },
        // 현장 사진
        {
          path: "scenePhoto",
          name: "scenePhoto",
          component: ScenePhoto,
          beforeEnter: requireAuth(),
        },
        // 3D 테스트
        {
          path: "test3dkyj",
          name: "test3dkyj",
          component: Test3dkyj,
          beforeEnter: requireAuth(),
        },
      ],
    },
    // 센서 모니터링
    {
      path: "/monitoring",
      name: "monitoring",
      component: SensorMonitoring,
      children: [],
      // beforeEnter: requireAuth()
    },
    {
      path: "/test3d",
      name: "Test3D",
      component: Test3D,
    },
    {
      path: "/testvr",
      name: "TestVR",
      component: TestVR,
    },
    {
      path: "/vrSensorData",
      name: "vrSensorData",
      component: VRSensorData,
    },
    {
      path: "/vrSiteCheckInfo",
      name: "vrSiteCheckInfo",
      component: VRSiteCheckInfo,
    },
    {
      path: "*",
      component: ErrorPage,
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js